import styled, { keyframes } from 'styled-components'

export type ShineBorderProps = {
  width?: number
  borderRadius?: number
} & (
  | {
      variant?: never
      shineColors: ShineColor
    }
  | {
      variant: ShineBorderVariant
      shineColors?: never
    }
)

type ShineColor = ReadonlyArray<string>

export type ShineBorderVariant = 'primary' | 'success'

const VariantColors: Record<ShineBorderVariant, ShineColor> = {
  primary: [
    'transparent',
    'transparent',
    'var(--blue-10)',
    'var(--blue-6)',
    'var(--cyan-11)',
    'transparent',
    'transparent',
  ],
  success: [
    'transparent',
    'transparent',
    'var(--acid-6)',
    'var(--acid-8)',
    'var(--acid-12)',
    'transparent',
    'transparent',
  ],
}

const shine = keyframes`
  from {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 100%;
  }
  to {
    background-position: 0 0;
  }
`
const ShineBorder_ = styled.div<ShineBorderProps>`
  background-image: radial-gradient(
    ${(_) =>
      _.variant ? VariantColors[_.variant].join(',') : _.shineColors.join(',')}
  );
  border-radius: ${(_) => (_.borderRadius ? `${_.borderRadius}px` : 'inherit')};
  background-size: 300% 300%;
  padding: ${(_) => _.width ?? 2}px;
  animation: ${shine} 20s infinite linear;
  will-change: background-position;

  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
`

export const ShineBorder = styled(ShineBorder_)`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`
